<h2 mat-dialog-title i18n>Update Related Records</h2>
<app-dialog-close mat-dialog-close></app-dialog-close>

<mat-dialog-content>
  <p i18n>
    You have made changes to a field that is linked to other records and can
    automatically update them. The following records are linked through the
    <b>
      "{{
        data.entities[0]?.relatedReferenceField
          | entityFieldLabel: data.entities[0]?.relatedReferenceFieldEntityType
      }}"
    </b>
    field. Please review these affected records below. You can manually change
    the new value if the automatically suggested value is not matching what you
    need.
  </p>

  <table class="full-width">
    @for (entity of data.entities; track entity.id) {
      <tr>
        <td>
          <app-entity-block [entityId]="entity.id"></app-entity-block>
        </td>
        <td>
          <app-entity-field-edit
            [field]="entity.selectedField"
            [entity]="entity.affectedEntity"
            [form]="entity.form"
            [hideInheritButton]="true"
          ></app-entity-field-edit>
        </td>
      </tr>
    }
  </table>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="onConfirm()" i18n>Update related records</button>
  <button mat-button mat-dialog-close i18n>Do not update</button>
</mat-dialog-actions>
